/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_Legend_SummaryInputs */



/**
* | output |
* | --- |
* | "What do GW / VP / TP mean?" |
*
* @param {Score_Legend_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const score_legend_summary = /** @type {((inputs?: Score_Legend_SummaryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_Legend_SummaryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Que signifient GW / VP / TP ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Qué significan GW / VP / TP?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O que significam GW / VP / TP?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cosa significano GW / VP / TP?")
	return /** @type {LocalizedString} */ ("What do GW / VP / TP mean?")
});